import { css, cva } from "@stubhub/broadway-foundation/css";

export const scrollWrapperStyle = css({
  overflowX: "auto",
  overflowY: "hidden",
  WebkitOverflowScrolling: "touch",
  scrollbarWidth: "[none]",
  "&::-webkit-scrollbar": { display: "none" },
});

export const rowStyle = css({
  display: "flex",
  columnGap: "primitives.100",
  rowGap: "primitives.100",
  paddingInline: "primitives.0",
  paddingBlock: "primitives.200",
  width: "full",
  boxSizing: "border-box",
});

export const cellRecipe = cva({
  base: {
    flexShrink: "1",
    flexGrow: "1",
    display: "flex",
    flexDirection: "column",
    columnGap: "primitives.50",
    rowGap: "primitives.50",
    paddingBlock: "primitives.150",
    paddingInline: "primitives.150",
    borderInlineWidth: "[1px]",
    borderBlockWidth: "[1px]",
    borderInlineStyle: "solid",
    borderBlockStyle: "solid",
    borderInlineColor: "border",
    borderBlockColor: "border",
    borderStartStartRadius: "element.default",
    borderStartEndRadius: "element.default",
    borderEndStartRadius: "element.default",
    borderEndEndRadius: "element.default",
    cursor: "pointer",
    backgroundColor: "bg.surface",
    "&:hover": {
      backgroundColor: "bg.surface.stronger",
    },
  },
  variants: {
    selection: {
      selected: {
        backgroundColor: "bg.surface.stronger",
        borderInlineColor: "border.strong",
        borderBlockColor: "border.strong",
      },
      unselected: {},
    },
  },
  defaultVariants: {
    selection: "unselected",
  },
});

export const chipsSpacingStyle = css({
  paddingBlockEnd: "primitives.300",
});

export const guaranteeHighlightsSpacingStyle = css({
  marginBlockStart: "primitives.200",
});

export const gaLocationContentStyle = css({
  maxWidth: "full",
  overflowX: "hidden",
  desktop: {
    maxWidth: "[none]",
    overflowX: "visible",
  },
});

export const gaLocationRowStyle = css({
  position: "relative",
  maxWidth: "full",
  overflowX: "hidden",
  paddingBlockEnd: "primitives.200",
  paddingBlockStart: "primitives.100",
  desktop: {
    paddingBlockStart: "primitives.0",
    overflowX: "visible",
  },
});

export const gaLocationTriggerRecipe = cva({
  base: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: "primitives.50",
    rowGap: "primitives.50",
    paddingInline: "primitives.0",
    paddingBlock: "primitives.0",
    backgroundColor: "[transparent]",
    borderBlockStartWidth: "[0]",
    borderBlockEndWidth: "[0]",
    borderInlineStartWidth: "[0]",
    borderInlineEndWidth: "[0]",
    color: "text",
    maxWidth: "full",
    overflowX: "hidden",
    overflowY: "hidden",
  },
  variants: {
    interaction: {
      interactive: { cursor: "pointer" },
      static: {},
    },
  },
  defaultVariants: {
    interaction: "static",
  },
});

export const gaLocationIconStyle = css({
  flexShrink: "[0]",
});

export const gaLocationTextStyle = css({
  fontSize: "primitives.350",
  fontWeight: "bold",
  lineHeight: "primitives.500",
  color: "text",
  overflowX: "hidden",
  overflowY: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  minWidth: "[0]",
  desktop: {
    fontSize: "primitives.400",
    fontWeight: "medium",
    overflowX: "visible",
    overflowY: "visible",
    textOverflow: "clip",
    whiteSpace: "normal",
  },
});

export const gaWeekendLabelStyle = css({
  fontSize: "primitives.350",
  fontWeight: "bold",
  lineHeight: "primitives.500",
  color: "text",
});

export const gaCardBodyCenterStyle = css({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});
